export default __webpack_public_path__ + "static/media/g-xl-4.ea5d7aec.png";